import "./boxed.css.ts.vanilla.js";
var e = "ihbkeq0";
export { e as inverseBorder };
